module.exports = "\n<div #videoContainer class=\"o-media-video-wrapper\">\n  <video #video id=\"video\" controls>\n      <source [src]=\"videoSrc\" type=\"video/mp4\">\n  </video>\n  <small class=\"o-media-video-stamp-tag\" *ngIf=\"videoStampTag\">\n      {{videoStampTag}}\n  </small>\n  <span class=\"o-media-video-stamp\" *ngIf=\"videoStamp\">\n    {{videoStamp}}\n  </span>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/video-player/video-player.component.html
// module id = ../../../../../src/app/shared/components/video-player/video-player.component.html
// module chunks = main